<template>
  <div>
    <bread-crumb></bread-crumb>
    <man-form-list
      :select="select"
      :selectList="selectList"
      @getChangeValue="getChangeValue"
      @empty="empty"
      :isBtn="isBtn"
      @disease_remoteMethod="getDiseases"
      :isShowFilter="isShowFilter"
      @searchFilter="searchFilter"
      @checkBoxedChange="checkBoxedChange"
      @clickSingleBoxed="clickSingleBoxed"
      @popHide="popHide"
      :searchFilterList="searchFilterList"
      :checkList="checkList"
    ></man-form-list>
    <div class="content-audit-tabel">
      <Sort
        :type="2"
        :tabActiveName="'提交时间'"
        ref="Sort"
        @getSortData="getSortData"
        v-if="sonRefresh"
      />
      <div class="base-table">
        <el-button type="text" @click="addBatchChannel">批量添加频道</el-button>
        <div class="base-table-table" ref="one">
          <el-table
            @selection-change="handleSelectionChange"
            :data="tableData"
            v-loading="loading"
            ref="multipleTable"
          >
            <el-table-column
              type="selection"
              :selectable="checkboxInit"
              width="65"
              align="center"
              fixed
            ></el-table-column>
            <el-table-column
              label="文章ID"
              prop="id"
              width="90"
            ></el-table-column>
            <el-table-column
              label="文章标题"
              prop="title"
              width="240"
            ></el-table-column>
            <el-table-column label="文章类型">
              <template slot-scope="scope">
                <span>{{ scope.row.articleType == 1 ? "图文" : "视频" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="写手昵称">
              <template slot-scope="scope" v-if="scope.row.contentUser">
                <span>{{
                  scope.row.contentUser.nickName
                    ? scope.row.contentUser.nickName
                    : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="医生信息">
              <template slot-scope="scope" v-if="scope.row.originalAuthor">
                <span>
                  {{
                    scope.row.originalAuthor.originalAuthorName +
                    " " +
                    scope.row.originalAuthor.originalAuthorTitle +
                    " " +
                    scope.row.originalAuthor.originalAuthorDepart +
                    " " +
                    scope.row.originalAuthor.originalAuthorUnit
                  }}
                </span>
              </template>
            </el-table-column>
            <!-- 内容质量 -->
            <el-table-column
              label="内容质量"
              prop="contentAttributes"
              width="120"
            >
              <template #header>
                <div style="display: flex">
                  <span>内容质量</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="内容质量来源于内容的基本素质和用户反馈等维度，“优秀”将获得更多的曝光机会"
                    placement="bottom-start"
                  >
                    <img
                      src="@/assets/mark.svg"
                      style="width: 15px; height: 15px"
                    />
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div v-for="item in scope.row.contentAttributes" :key="item.id">
                  <span v-if="item.type == 29">{{ item.desc }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- 总浏览量 -->
            <el-table-column width="120" prop="pv" label="总浏览量">
            </el-table-column>
            <el-table-column
              label="投稿时间"
              prop="submitTime"
              width="100"
            ></el-table-column>
            <el-table-column label="内容索引">
              <template slot-scope="scope" v-if="scope.row.contentIndexes">
                <p>
                  {{
                    scope.row.contentIndexes.length > 0
                      ? scope.row.contentIndexes[
                          scope.row.contentIndexes.length - 1
                        ].name
                      : "-"
                  }}
                </p>
              </template>
            </el-table-column>

            <!-- <el-table-column label="文章评级" prop="level">
              <template slot-scope="scope" v-if="scope.row.attributeLevel">
                <div
                  v-for="(item, index) in scope.row.attributeLevel"
                  :key="index"
                >
                  <p>{{ item.desc }}</p>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="文章标签" prop="tag" width="200">
              <template
                slot-scope="scope"
                v-if="scope.row.extensionContentLabels"
              >
                <div
                  v-for="(item, index) in scope.row.extensionContentLabels"
                  :key="index"
                >
                  <p>{{ item.name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="分发范围" prop="range">
              <template slot-scope="scope" v-if="scope.row.distributeScope">
                <div
                  v-for="(item, index) in scope.row.distributeScope"
                  :key="index"
                >
                  <p>
                    {{ item.desc }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="所属频道" prop="channelId">
              <template
                slot-scope="scope"
                v-if="scope.row.distributeContentChannels"
              >
                <div
                  v-for="(item, index) in scope.row.distributeContentChannels"
                  :key="index"
                >
                  <p>{{ item.channelName }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="text"
                    size="small"
                    @click="viewArticle(scope.row)"
                    >查看文章
                  </el-button>
                  <span class="border"></span>
                  <el-button type="text" size="small" @click="addChannel(scope)"
                    >添加频道
                  </el-button>
                  <span class="border"></span>
                  <el-button
                    type="text"
                    size="small"
                    @click="viewOnline(scope.row)"
                    >查看线上
                  </el-button>
                  <span class="border"></span>
                  <el-button
                    type="text"
                    size="small"
                    @click="copyLink(scope.row)"
                    >复制线上链接
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          @sizePageChange="paginationChangeProduct"
          :paginationDatas="paginationDataProduct"
        ></pagination>
        <el-dialog
          title="添加频道"
          :visible.sync="dialogTableVisible"
          width="50%"
          @close="closeDialog"
          @open="oneDialog"
        >
          <div style="height: 70vh; overflow: auto">
            <distribution-tag
              :tenantId="tenantId"
              ref="businessColumnChannel"
            ></distribution-tag>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelChannelSubmission">取 消</el-button>
            <el-button type="primary" @click="addChannelSubmission"
              >提 交</el-button
            >
          </span>
        </el-dialog>
        <preview-modal
          :mUrl.sync="mUrl"
          :dialogPreVisible.sync="dialogPreVisible"
          :qrCode="qrCode"
        ></preview-modal>
        <active-modal
          :dialogData.sync="tableVal"
          :dialogPreVisible.sync="activeDialogPreVisible"
        ></active-modal>
      </div>
    </div>
  </div>
</template>

<script>
import breadCrumb from "../../../../../components/breadCrumb";
import manFormList from "../../../components/manFormList";
import DistributionTag from "../../../../../components/tag/DistributionTag";
import PreviewModal from "../../../../../components/pop/PreviewModal";
import ActiveModal from "../../../../../components/pop/AddActiveDialog";
import pagination from "../../../../../components/pagination";
import Sort from "../../../components/sort";
import { copyUrl } from "@/utils/tools";
import {
  getOnlineLinks,
  addChannels,
  addBatchChannel,
  oneDialog,
  addChannelSubmission,
  cancelChannelSubmission,
  searchDataProcessing,
  getDistributionListData,
  empty,
  closeDialog,
  getGeneralLabel,
  getDiseasesData,
  getBusiness,
  getContentNature,
  getDistributionScope,
  handleSelectionChange,
  storeInformation,
  initializeJump,
  getContentQuailty,
  getContentSources,
} from "../distribution";
import {
  manSaveUserConfig,
  manListUserConfig,
  listContentBusinessForUserMan,
} from "@/api/man";
import { request } from "@/utils/axios";
import { queryDistributionList } from "../../../../../api/contentDistribution";
import { manListContentIndexTree } from "@/api/indexs";

export default {
  name: "contentDistribution",
  components: {
    DistributionTag,
    PreviewModal,
    breadCrumb,
    manFormList,
    pagination,
    ActiveModal,
    Sort,
  },
  data() {
    return {
      sonRefresh: true,
      isBtn: 1,
      channelType: null,
      dialogTableVisible: false,
      dialogPreVisible: false,
      loading: false,
      activeDialogPreVisible: false,
      tableVal: {},
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      businessChannelArr: [],
      select: [
        {
          prop: "articleId",
          type: "input2",
          placeholder: "请输入文章ID进行检索",
          maxLenth: 18,
        },
        // {
        //   prop: 'articleKeyWord',
        //   type: 'input',
        //   placeholder: '请输入标题关键词检索',
        //   maxLenth: 50
        // },
        // {
        //   prop: 'diseaseLabel',
        //   type: 'disease',
        //   placeholder: '请输入疾病',
        //   List: []
        // }
      ],
      select1: [
        {
          prop: "articleId",
          type: "input2",
          placeholder: "请输入文章ID进行检索",
          maxLenth: 18,
        },
        {
          prop: "articleKeyWord",
          type: "input",
          placeholder: "请输入标题关键词检索",
          maxLenth: 50,
        },
        {
          prop: "diseaseLabel",
          type: "disease",
          placeholder: "请输入疾病",
          maxLenth: 50,
          List: [],
        },
        {
          prop: "nickname",
          type: "input",
          placeholder: "请输入写手昵称进行检索",
          maxLenth: 50,
        },
        {
          prop: "writerPin",
          type: "input",
          placeholder: "请输入写手Pin进行检索",
          maxLenth: 50,
        },
        {
          prop: "doctorName",
          type: "input",
          placeholder: "请输入医生姓名进行检索",
          maxLenth: 50,
        },
        {
          prop: "hospital",
          type: "input",
          placeholder: "请输入医院名称进行检索",
          maxLenth: 50,
        },
        {
          prop: "department",
          type: "input",
          placeholder: "请输入科室名称进行检索",
          maxLenth: 50,
        },
        {
          prop: "articleType",
          type: "select",
          placeholder: "请选择文章类型检索",
          List: [
            {
              value: "",
              label: "全部",
            },
            {
              value: 1,
              label: "图文",
            },
            {
              value: 7,
              label: "视频",
            },
          ],
        },
        {
          prop: "submissionTime",
          type: "picker",
          placeholder: "请选择投稿时间",
          //   List:[]
        },
        {
          prop: "isOriginal",
          type: "select",
          placeholder: "是否原创",
          List: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "原创",
            },
            {
              value: "2",
              label: "转载",
            },
          ],
        },
        {
          prop: "business",
          type: "select",
          placeholder: "请输入所属业务",
          multiple: true,
          List: [],
        },
        {
          prop: "categoryId",
          type: "select",
          placeholder: "请输入所属栏目",
          multiple: true,
          List: [],
        },
        {
          prop: "channelId",
          type: "select",
          placeholder: "请输入所属频道",
          multiple: true,
          List: [],
        },
        {
          prop: "contentIndexIds",
          type: "selectIndex",
          placeholder: "请选择索引",
          List: [],
        },
        {
          prop: "level",
          type: "select",
          placeholder: "文章级别",
          List: [],
          levelList: [],
        },
        {
          prop: "range",
          type: "select",
          placeholder: "分发范围",
          List: [],
        },
        {
          prop: "articleLabel",
          type: "selectCascader",
          placeholder: "文章标签",
          List: [],
        },
        {
          prop: "keyWords",
          type: "input",
          placeholder: "请输入全文关键词检索",
          maxLenth: 50,
        },
      ],
      selectList: {
        articleId: "", //文章ID
        articleKeyWord: "", // 文章关键字
        keyWords: "", // 文章关键字
        diseaseLabel: null, // 疾病标签
        articleLabel: [], // 文章标签
        nickname: "", // 写手昵称
        writerPin: "", // 写手Pin
        doctorName: "", // 医生名字
        hospital: "", // 医院名称
        department: "", // 科室名称
        business: [], // 所属业务
        categoryId: [], // 所属栏目
        channelId: [], // 所属频道
        level: "", // 文章级别
        nature: "", // 内容性质
        range: "", // 分发范围
        quality: "", // 内容质量
        contentDiseasesNotNull: "",
        isDoctor: "",
        articleType: "", // 文章类型
        submissionTime: [], // 投稿时间
        auditTime: [], //
        featuredArticle: "", // 精选文章
        isOriginal: "", // 是否原创
        sortOrderParams: [],
        questionSource: null, // 问题来源
        videoType: "",
        videoDuration: {
          // startNum: -100,
          // endNum: -100
        }, // 视频时长
        videoText: {
          // startNum: -100,
          // endNum: -100
        }, // 视频正文
      },
      searchFilterList: [],
      multipleSelection: [],
      contentAttributes: [],
      tableData: [],
      natureList: [], // 内容性质
      rangeList: [], // 分发范围
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      form: {
        contentChannels: [],
      },
      tenantId: "", // 文章id
      mUrl: "",
      qrCode: "",
      isShowFilter: 1,
      questionFrom: [],
      contentType: "1",
    };
  },
  async created() {
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    this.initializeJump();
    this.getBusiness(); // 获取业务
    this.getContentNature(); // 获取内容性质
    this.getDistributionScope(); // 获取分发范围
    // 获取内容质量
    this.getContentQuailty();
    this.getGeneralLabel(); // 通用标签
    this.getDistributionListData(); // 获取列表
    this.listContentBusinessForUserMan();
    this.getIndexTreeList();
    getContentSources(this);
  },
  mounted() {
    setTimeout(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(".el-cascader-node[aria-owns]");
      console.log($el);
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    }, 300);
  },
  methods: {
    getSortData(val) {
      this.selectList.sortOrderParams = val;
      this.getChangeValue();
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.indexTreeList = res;
        this.select.map((subItem) => {
          if (subItem.prop == "contentIndexIds") {
            subItem.List = res;
          }
        });
      });
    },
    // 过滤
    searchFilter() {},
    // 配置项勾选
    checkBoxedChange(value) {
      // console.log(value.length, 'contentAudit======>',this.select, this.checkList);
      //  // 页面上展示搜索
      //  let tempSelectList = [];
      // this.allSearchList.map((item) => {
      //     // console.log(item, '========>|||||||');
      //     item?.selectItems?.map((subItem) => {
      //         if (value.includes(subItem.cfgID)) {
      //           // console.log(subItem, '点击=====》');
      //           this.configSubItem(subItem);
      //           tempSelectList.push(subItem);
      //         }
      //         if (value.length < this.checkList.length) {
      //           // 取消了某个配置 清空数据
      //            if (this.checkList.includes(subItem.cfgID) && !value.includes(subItem.cfgID)) {
      //                 this.selectList[subItem.prop] = '';
      //            }
      //         }
      //     })
      // })
      // // 添加的是 业务/栏目/渠道
      // this.checkList = value;
      // this.select = tempSelectList;
    },
    // 点击
    clickSingleBoxed(checked, item) {
      console.log("clickSingleBoxed======>", checked, item);
      if (checked) {
        // 添加
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            this.configSubItem(busItem);
            this.select.push(busItem);
          });
          this.checkList.push(item.cfgID);
        } else {
          this.checkList.push(item.cfgID);
          this.configSubItem(item);
          this.select.push(item);
        }
      } else {
        // 删除
        this.checkList = this.checkList.filter((value) => {
          if (value == item.cfgID) return false;
          return true;
        });
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            busItem.List = [];
            this.selectList[busItem.prop] = "";
          });
        } else {
          this.selectList[item.prop] = "";
        }
        this.select = this.select.filter((value) => {
          if (value.cfgID == item.cfgID) return false;
          return true;
        });
      }
      let selecrData = JSON.stringify(this.select);
      sessionStorage.setItem("disBuSelectData", selecrData); // 存入筛选选择数据
    },
    configSubItem(subItem) {
      if (subItem.cfgID == 3004) {
        let arr = this.qualityList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 3003) {
        let arr = this.rangeList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 4000 && subItem.prop == "business") {
        subItem.List = this.businessList;
      }
      if (subItem.cfgID == 4001) {
        subItem.List = this.articleLabels;
      }
      if (subItem.cfgID == 4002) {
        subItem.List = this.indexTreeList;
      }
      if (subItem.cfgID == 5004) {
        subItem.List = this.questionFrom;
      }
      // if ([3000,3001,3002,3003,3004,5002,5003].includes(subItem.cfgID)){
      //     this.selectList[subItem.prop] = "全部";
      // }
    },
    // 配置项隐藏
    popHide(value) {
      console.log(value, "contentAudit--popHide");
      this.saveUserConfig({
        configId: this.configId,
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "2",
        value: value.toString(),
      });
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      // console.log('queryFloorList=======>', 33333);
      await request("jdh_laputa_queryFloorList", {
        functionId: "distributionMarket",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 5,
      })
        .then(async (res) => {
          // this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          // console.log(res?.cf?.floorTransferDTOS[0], 'contentAudit<----来了哥----->');
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg") {
                return true;
              }
              return false;
            }
          );
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          // console.log(valueArray, 'contentAudit<----来了哥----->valueArray');
          let fileterArray = [];
          let allShowSearchArr = [];
          // console.log( '=====>|||||========>',valueArray);
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);
              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('==============ppppppppp');
                this.checkList = item?.selectedIDs;
              }
            }
          });
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(fileterArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(this.select, 'queryFloorList=====>|||||======');
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "2",
      }).then((res) => {
        if (res && res?.length > 0) {
          // console.log(res, '===============>配置');
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          // console.log(this.checkList, '===============>配置', this.serverList);
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    getContentQuailty() {
      getContentQuailty(this);
    },
    checkboxInit(row, index) {
      let arr = row.contentAttributes;
      if (arr) {
        for (let item of arr) {
          if (item.type == 6) {
            return item.code == "1";
          }
        }
      }
    },
    // 复制链接
    copyLink(row) {
      this.activeDialogPreVisible = true;
      this.tableVal = row;
    },
    // 查看文章
    viewArticle(val) {
      this.$router.push({
        path: "/contentDistribution/articles",
        query: {
          id: val.id,
          type: val.articleType,
          distribution: 1, // 内容分发
        },
      });
      this.storeInformation();
    },
    // 跳转存储信息
    storeInformation() {
      storeInformation(1, this);
    },
    initializeJump() {
      if (sessionStorage.getItem("distribution")) {
        let page = JSON.parse(sessionStorage.getItem("disBuPage"));
        let selectStr = JSON.parse(sessionStorage.getItem("disBuSelectList"));
        let selecrData = JSON.parse(sessionStorage.getItem("disBuSelectData"));
        this.paginationDataProduct = page;
        this.selectList = selectStr;
        this.select = selecrData;
      } else {
        initializeJump(this);
      }
    },
    // 查看线上
    viewOnline(row) {
      this.dialogPreVisible = true;
      this.getOnlineLink(row);
    },
    // 获取线上链接
    getOnlineLink(row, cope) {
      // 公用方法
      getOnlineLinks(row, cope, this);
    },
    // 添加频道
    addChannel(val) {
      // 公用方法
      addChannels(val, this);
    },
    // 批量添加
    addBatchChannel() {
      // 公共方法
      addBatchChannel(this);
    },
    // el-dialog打开回调
    oneDialog() {
      oneDialog(this);
    },
    // 批量添加频道提交
    addChannelSubmission() {
      addChannelSubmission(this);
    },
    // 批量添加频道取消
    cancelChannelSubmission() {
      cancelChannelSubmission(this);
    },
    getChangeValue() {
      this.getDistributionListData(1);
    },
    // 搜索内容属性处理
    searchDataProcessing() {
      searchDataProcessing(this);
    },
    // 内容性质、文章级别、内容分发数据统一梳理方法
    dataTraversal(list, name) {
      list.map((item) => {
        if (item.id == name) {
          let arr = {};
          arr.code = item.code;
          arr.type = item.type;
          this.contentAttributes.push(arr);
        }
      });
    },
    // 获取列表数据
    getDistributionListData(val) {
      this.searchDataProcessing();
      getDistributionListData(queryDistributionList, this, val);
    },
    // 清空
    empty() {
      this.sonRefresh = false;
      this.$nextTick(() => {
        this.sonRefresh = true;
      });
      empty(this);
      this.getDistributionListData();
    },
    // 表格多选
    handleSelectionChange(val) {
      handleSelectionChange(val, this);
    },
    // 分页
    paginationChangeProduct(val) {
      this.getDistributionListData();
      this.paginationDataProduct = val;
    },
    // 弹窗关闭事件
    closeDialog() {
      closeDialog(this);
    },
    // 获取通用标签
    getGeneralLabel() {
      getGeneralLabel(this);
    },
    // 查询疾病库名称
    getDiseases(val) {
      getDiseasesData(val, this);
    },
    // 查询所属业务
    getBusiness() {
      getBusiness(this);
    },
    // 查询内容性质
    getContentNature() {
      getContentNature(this);
    },
    // 查询分发范围
    getDistributionScope() {
      getDistributionScope(this);
    },
    //查询当前运营所有的业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          // 改版注掉f
          // this.select[13].List.push({
          //   label: item.name,
          //   value: item.id
          // })
          // console.log(res, 'listContentBusinessForUserMan====>',);
          this.businessList.push({
            label: item.name,
            value: item.id,
          });
          this.select.map((subItem) => {
            if (subItem.prop == "business" && subItem.cfgID == 4000) {
              subItem.List.push({
                label: item.name,
                value: item.id,
              });
            }
            return subItem;
          });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.el-dialog__footer) {
  text-align: center;
}

.channel-item {
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

:deep(.el-table th > .cell) {
  padding-right: 5px;
}
</style>
